import * as React from 'react'
import * as Redux from 'react-redux'
import { styled } from 'next-yak'

import * as plume from '@ulule/owl-kit-components/next'

import * as model from '@owl-nest/models'

import { RootState } from '../../../../reducers'
import * as projectModel from '../../../models/project'

export function ComingSoonHeader(): React.ReactElement<unknown> {
  const project = Redux.useSelector<RootState, projectModel.Project>((state) => state.application.project.data)

  return (
    <Wrapper>
      <plume.UserLabel
        avatar={model.user.avatar(project.owner, '90x90')}
        avatarSize="medium"
        isPublic={project.owner.is_public}
        href={project.owner.absolute_url}
        name={<plume.styles.heading.XS>{model.user.username(project.owner)}</plume.styles.heading.XS>}
      />

      <plume.glyphs.stroke.Close size={22} />
      <a href="/">
        <plume.logos.ulule.HorizontalLogo />
      </a>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  align-content: center;
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: 0 16px;
  padding-bottom: 20px;
  padding-top: 26px;

  ${plume.glyphs.stroke.Close} {
    color: ${plume.COLORS.PRIMARY_GREY_500};
    margin: 0 22px;
  }

  ${plume.styles.heading.XS} {
    margin-left: 6px;
    width: 70%;
  }

  @media screen and ${plume.BREAKPOINTS.TABLET} {
    ${plume.styles.heading.XS} {
      margin-left: 6px;
      width: 100%;
    }
  }
`
